export const Textbook = {
  // 교재 지급
  Dist: {
    // 수납 처리 방식
    BillingType: {
      separate: 1, // 별도수납
      bill: 2, // 청구서 작성
      monthly: 3, // 월별 교재비 청구서에 추가
    },
  },

  // 학생별 지급 교재
  DistItem: {
    // 가격 적용 방식
    PriceType: {
      regular: 1, // 정가
      discount: 2, // 할인가
      gift: 3, // 증정
    },

    // 지급 상태
    Status: {
      distributed: 1, // 지급
      canceled: 2, // 지급취소
    },
  },

  // XLSX 대량 등록
  Xlsx: {
    // 행별 처리 결과
    RowStatus: {
      created: 1, // 신규 등록
      updated: 2, // 기존 교재 업데이트
      unchanged: 3, // 변경 없음
      needsReview: 4, // 등록 보류
      failed: 5, // 등록 실패
    },

    // 등록 충돌 유형
    ConflictType: {
      sameIsbnDifferentIdentity: 1, // 동일 ISBN·다른 식별정보, 허용 가능
      sameIdentityDifferentIsbn: 2, // 동일 식별정보·다른 ISBN, 절대 허용 불가
      sameManagementCodeDifferentIdentity: 3, // 동일 관리코드·다른 식별정보, 절대 허용 불가
      sameIdentityDifferentManagementCode: 4, // 동일 식별정보·다른 관리코드, 절대 허용 불가
    },
  },
};
